import styled from "styled-components"

import { minWidth } from "utils"

export const List = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem 2rem;
  clear: both;

  ${minWidth.tablet`
    width: auto;
    max-width: 58rem;
    margin: 0 auto 4rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
    margin: 0 auto 6rem;
  `}
`

export const Title = styled.h2`
  padding-bottom: 0.6rem;
  border-bottom: 0.3rem solid #f3f3f3;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 3rem;
  line-height: 1.333;

  ${minWidth.tablet`
    font-size: 2.8rem;
  `}
`

export const Items = styled.div`
  padding: 1rem 0;
  border-bottom: 0.1rem solid #f3f3f3;
  display: flex;
  flex-direction: column;

  ${minWidth.tablet`
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  `}
`
